import { Modal } from "../../../../../components/modal-base";
import theme from "../../../../../styles/theme";
import { Close, Check } from "@mui/icons-material";
import { ButtonContainer, ModalContent } from "./styles";

interface IConfirmPurchase {
  modal: boolean;
  toggleModal: () => void;
}

export const GetInTouch: React.FC<IConfirmPurchase> = ({
  modal,
  toggleModal,
}) => {
  return (
    <Modal.Root maxWidth="600px" open={modal} onClose={toggleModal}>
      <Modal.Header justifyContent="end">
        <Modal.HeaderText text="Pacote personalizado" />
        <Modal.Icon
          icon="Close"
          cursor="pointer"
          onClick={toggleModal}
          iconColor={theme.colors.brown.capivara}
        />
      </Modal.Header>
      <Modal.Content>
        <ModalContent>
          <h3 style={{ alignSelf: "center" }}>
            Fale com o Puxa Capivara para mais informações!
          </h3>
        </ModalContent>
        <ButtonContainer>
          <Modal.Button
            onClick={toggleModal}
            startIcon={<Close />}
            bgColor="#FDF8F0"
            color="black"
          >
            Cancelar
          </Modal.Button>
          <Modal.Button
            onClick={() => {
              toggleModal();
              window.open('https://wa.me/5562982385485?text=Gostaria%20de%20comprar%20um%20pacote%20de%20consultas', '_blank')
            }}
            startIcon={<Check />}
            bgColor="#2C2C2C"
            color="white"
          >
            Entrar em contato
          </Modal.Button>
        </ButtonContainer>
      </Modal.Content>
    </Modal.Root>
  );
};
